module.exports = __webpack_public_path__ + "media/images/icon/sync-solid-9dc210e856863a8dd9f0880f9e1db8d1.svg";